import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService, StoreService } from '@seu-services';
import { SeuConfigTranslationObject, SeuLanguage } from '@seu-types';
import { last } from 'lodash-es';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigTranslation',
})
export class SeuConfigTranslationPipe implements PipeTransform {
  private readonly store = inject(StoreService);
  private readonly languageService = inject(LanguageService);

  public transform(value: string): string {
    // Use current language from LanguageService
    const lang: SeuLanguage = this.languageService.getLang();

    // Handle special case for labels that include dots
    if (value.includes(':DOT:')) {
      return last(value.split(':DOT:')) || '';
    }

    const keyArray = value.split('.');
    let returnValue: string | null = keyArray[keyArray.length - 1];
    // Fallback to 'de' if the language key doesn't exist in translations
    const translations = this.store.getConfig().translations;
    let translationObject = translations[lang];

    keyArray.forEach((key: string) => {
      if (translationObject) {
        const translationValue = translationObject[key];
        if (translationValue) {
          if (typeof translationValue === 'object') {
            translationObject = translationValue as SeuConfigTranslationObject;
          } else if (typeof translationValue === 'string') {
            returnValue = translationValue;
          }
        } else if (translationValue === '') {
          returnValue = '';
        }
      }
    });

    return returnValue;
  }
}
